import {
  IAMAccountIdentity,
  iamAccountIdentity,
  IAMAccountRawPassword,
  iamAccountRawPassword
} from "@youm-front/iam-account/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class IAMAccountSignInRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountSignInRequestDTO.validationSchema()
  );

  constructor(readonly data: IAMAccountSignInRequestDTORaw) {
    JsonSchemaValidator.validate(IAMAccountSignInRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["identity", "password"],
      properties: {
        identity: iamAccountIdentity,
        password: iamAccountRawPassword
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountSignInRequestDTORaw {
  identity: IAMAccountIdentity;
  password: IAMAccountRawPassword;
}
